export const TEST_CONST = 100;
export const COMPANY_EMAIL = 'support@reprism.com';
export const TRASH_AUTO_DELETE_DAYS = 30;
